/* External */
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

/* Providers */
import { useIsBrazil } from '../../../providers/ConfigProvider';

/* Utils */
import { createAccountUrlBR, createAccountUrlSSLA } from '../../../utils/env';

const getValues = (isBrazil) => ({
  span: (chunks) => (
    <span className="dtv-html5-c-create-account__content-url">{chunks}</span>
  ),
  url: isBrazil ? createAccountUrlBR : createAccountUrlSSLA,
});

function Steps() {
  const isBrazil = useIsBrazil();
  const values = getValues(isBrazil);

  return (
    <p className="dtv-html5-c-create-account__content-description">
      <FormattedMessage
        id="createAccount.description"
        values={values}
      />
    </p>
  );
}

export default memo(Steps);
